import React, { Component } from 'react'
import Link from 'next/link'
import PropTypes from 'prop-types'
import Router, { withRouter } from 'next/router'
import styled from 'styled-components'

import HomeRoundedIcon from '@mui/icons-material/HomeRounded'
import MenuRoundedIcon from '@mui/icons-material/MenuRounded'
import DiamondRoundedIcon from '@mui/icons-material/DiamondRounded'
import PersonRoundedIcon from '@mui/icons-material/PersonRounded'
import QuestionMarkRoundedIcon from '@mui/icons-material/QuestionMarkRounded'
import EmailRoundedIcon from '@mui/icons-material/EmailRounded'
import styles from '../../../constants/styles'

const paths = [
  { icon: <HomeRoundedIcon />, name: 'home', title: 'Home' },
  { icon: <MenuRoundedIcon />, name: 'feed', title: 'Feed' },
  { icon: <DiamondRoundedIcon />, name: 'resources', title: 'Resources' },
  { icon: <PersonRoundedIcon />, name: 'account', title: 'Account' },
  { icon: <QuestionMarkRoundedIcon />, name: 'faq', title: 'FAQ + T&C' },
  { icon: <EmailRoundedIcon />, name: 'contact', title: 'Contact' }
]

class AmbassadorSideNav extends Component {
  constructor(props) {
    super(props)
    this.state = {
      tab: ''
    }
    this.tabHasChanged = this.tabHasChanged.bind(this)
  }

  // changing url is remounting the comp.
  componentDidMount() {
    const {
      router: {
        query: { tab }
      }
    } = this.props
    // if manually entering random url, redirect to /home
    if (!paths.map((p) => p.name).includes(tab)) {
      Router.replace('/dashboard/home')
    }
    this.setState({ tab })

    Router.events.on('routeChangeStart', this.tabHasChanged)
  }

  componentWillUnmount() {
    Router.events.off('routeChangeStart', this.tabHasChanged)
  }

  tabHasChanged(path) {
    const tab = path.split('/dashboard/')[1]
    if (tab) {
      if (paths.map((p) => p.name).includes(tab)) {
        this.setState({ tab })
      } else {
        this.setState({ tab: 'home' })
        Router.replace('/dashboard/home')
      }
    }
  }

  render() {
    const { tab } = this.state

    return (
      <Container>
        <Links>
          {paths.map(({ name, icon, title }) => (
            <Link key={name} href={`/dashboard/${name}`}>
              <LinkBox active={tab === name}>
                <Icon>{icon}</Icon>
                <Title>{title}</Title>
              </LinkBox>
            </Link>
          ))}
        </Links>
      </Container>
    )
  }
}

AmbassadorSideNav.propTypes = {
  router: PropTypes.objectOf(PropTypes.any).isRequired,
  campaignActive: PropTypes.bool
}

export default withRouter(AmbassadorSideNav)

const Container = styled.div`
  width: 200px;
  max-height: calc(100vh - 64px - 245px);
  background-color: ${styles.colors.white};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  position: sticky;
  top: '64px';
  @media (max-width: 900px) {
    display: none;
  }
`

const Links = styled.div`
  width: 100%;
  overflow: auto;
`

const LinkBox = styled.div`
  width: 100%;
  height: 48px;
  font-size: 1em;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  padding: 0 ${styles.padding.large};
  color: ${(props) =>
    props.active ? styles.colors.ambassador : styles.colors.black};
  background-color: ${(props) =>
    props.active ? styles.colors.veryLightGrey : styles.colors.white};
  border-left: 6px solid
    ${(props) =>
      props.active ? styles.colors.ambassador : styles.colors.white};

  &:hover {
    background-color: ${styles.colors.veryLightGrey};
    color: ${(props) =>
      props.active ? styles.colors.ambassador : styles.colors.darkGrey};
    border-left: 6px solid
      ${(props) =>
        props.active ? styles.colors.ambassador : styles.colors.darkGrey};
  }
`

const Icon = styled.span`
  font-size: 1em;
  width: 1em;
  display: flex;
  justify-content: center;
  margin-right: ${styles.margin.medium};
`

const Title = styled.span``
